import { useEffect, useState } from 'react';
import { fetchPlans, PLAN_FALLBACK, type Plans } from '@/services/plans';

/**
 * usePlans - the plan table (limits and prices) for the free and premium plans.
 * Returns the backend defaults straight away and the live numbers once they load.
 */
export function usePlans(): Plans {
  const [plans, setPlans] = useState<Plans>(PLAN_FALLBACK);
  useEffect(() => {
    let cancelled = false;
    fetchPlans().then((p) => {
      if (!cancelled) setPlans(p);
    });
    return () => {
      cancelled = true;
    };
  }, []);
  return plans;
}
